export default "__VITE_ASSET__0540daf1__"